export function formatPhone(phone?: string | null): string {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  return digits.replace(/^(\d{2})(\d{5})(\d{4}).*$/, '($1) $2-$3');
}

export function formatZipCode(zip?: string | null): string {
  if (!zip) return '';
  const digits = zip.replace(/\D/g, '').slice(0, 8);
  return digits.replace(/^(\d{5})(\d{3})$/, '$1-$2');
}

export function sanitizeSlug(text: string): string {
  if (!text) return '';

  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export const TOP_NAV_HUB_SOLUCOES = 'Hub de Soluções';